import React from "react";
import styles from "./Dashboards.module.css";
import { Link } from "react-router-dom";

import LogoDash from "../../assets/ic_dashboard_red.svg";

const DashBoards = () => {
  return (
    <main className="container">
      <div className="container-page">
        <section className={`${styles.sectionDashboards} container`}>
          <div className="title-page">
            <img src={LogoDash} className={styles.iconDash} />
            <h1>DashBoards</h1>
          </div>
          <section className={styles.containerBtnDash}>
            <Link to="/dashboards/dash-portais">
              <button className={`${styles.buttonDashboards}`}>
                Dash Portais
              </button>
            </Link>
            <Link to="/dashboards/indicadores-blog">
              <button className={`${styles.buttonDashboards}`}>
                Indicadores Blog
              </button>
            </Link>
            <Link to="/dashboards/indicadores-seo">
              <button className={`${styles.buttonDashboards}`}>
                Indicadores SEO
              </button>
            </Link>
            <Link to="/dashboards/dash-cms">
              <button className={`${styles.buttonDashboards}`}>Dash CMS</button>
            </Link>

            <Link to="/dashboards/report-mensal-portais">
              <button className={`${styles.buttonDashboards}`}>
                Report Mensal Portais
              </button>
            </Link>
            <Link to="/dashboards/report-mensal-seo">
              <button className={`${styles.buttonDashboards}`}>
                Report Mensal SEO
              </button>
            </Link>
            <Link to="/dashboards/sitemap-concorrentes">
              <button className={`${styles.buttonDashboards}`}>
                Sitemap Concorrentes
              </button>
            </Link>
            <Link to="/dashboards/links-quebrados">
              <button className={`${styles.buttonDashboards}`}>
                Links Quebrados
              </button>
            </Link>
            <Link to="/dashboards/sherlock">
              <button className={`${styles.buttonDashboards}`}>Sherlock</button>
            </Link>
            <Link to="/dashboards/inmetro">
              <button className={`${styles.buttonDashboards}`}>Inmetro</button>
            </Link>
            <Link to="/dashboards/galvao-bueno">
              <button className={`${styles.buttonDashboards}`}>
                Galvão Bueno
              </button>
            </Link>
            <Link to="/dashboards/vitrine-mensuracao">
              <button className={`${styles.buttonDashboards}`}>
                Vitrine Mensuração
              </button>
            </Link>
            <Link to="/dashboards/menusca">
              <button className={`${styles.buttonDashboards}`}>Menusca</button>
            </Link>
            <Link to="/dashboards/bolt-snt">
              <button className={`${styles.buttonDashboards}`}>Bolt Snt</button>
            </Link>
            <Link to="/dashboards/pipefy-opec">
              <button className={`${styles.buttonDashboards}`}>
                Pipefy OPEC
              </button>
            </Link>
            <Link to="/dashboards/pipefy-cms">
              <button className={`${styles.buttonDashboards}`}>Pipefy</button>
            </Link>
            <Link to="/dashboards/vitrine-bases-manuais">
              <button className={`${styles.buttonDashboards}`}>
                Vitrine - Upload Bases Manuais
              </button>
            </Link>
            <Link to="/dashboards/comprovantes">
              <button className={`${styles.buttonDashboards}`}>
                Componentes
              </button>
            </Link>
            <Link to="/dashboards/onboarding">
              <button className={`${styles.buttonDashboards}`}>
                Onboarding
              </button>
            </Link>
          </section>
        </section>
      </div>
    </main>
  );
};

export default DashBoards;
